import { AppBar, Stack, styled, SwipeableDrawer } from '@ethings/ui-toolkit';
import { Toolbar, useTheme } from '@mui/material';
import { FC, PropsWithChildren, RefObject, type JSX } from 'react';
import { UI_TEMPLATE_DRIVEN_SIDEBAR_FLAG } from '../../feature-flags';
import { useBoolFlag } from '../flags';
import { FlexBox } from '../flex-box';

interface Props extends PropsWithChildren {
  drawerContent: JSX.Element;
  drawerOpen: boolean;
  drawerRef?: RefObject<HTMLDivElement | undefined>;
  drawerWidth?: number;
  onDrawerClose: () => void;
  onDrawerOpen: () => void;
  toolbar: JSX.Element;
}

const StyledSwipeableDrawer = styled(SwipeableDrawer)({
  display: 'flex',
});

export const AppMobileLayout: FC<Props> = ({ children, drawerContent, drawerOpen, drawerRef, drawerWidth = '100%', onDrawerClose, onDrawerOpen, toolbar }) => {
  const theme = useTheme();
  const isUiTemplateDrivenSidebar = useBoolFlag(UI_TEMPLATE_DRIVEN_SIDEBAR_FLAG);

  return (
    <Stack className="App-root mobile" data-testid="app-page" direction="column" flexGrow={1} width="100%">
      <AppBar position="static">{toolbar}</AppBar>
      <Stack direction="row" flexGrow={1} overflow="hidden">
        <StyledSwipeableDrawer
          data-testid="app-drawer"
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            ref: drawerRef,
            sx: {
              display: 'flex',
              width: drawerWidth,
              backgroundColor: theme.sidebar.background,
              color: theme.sidebar.contrastText,
            },
          }}
          onClick={onDrawerClose}
          onClose={onDrawerClose}
          onOpen={onDrawerOpen}
          open={drawerOpen}
        >
          {!isUiTemplateDrivenSidebar &&
            <Toolbar />
          }
          {drawerContent}
        </StyledSwipeableDrawer>
        <FlexBox data-testid="app-body-wrapper" sx={{ minWidth: 0, flexDirection: 'column' }} >
          {children}
        </FlexBox>
      </Stack>
    </Stack >
  );
};
